import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasPermission, getHomeRoute } from '../utils/permissions';
import { hasStoreSelected } from '../utils/tenant';

export const ProtectedRoute = ({ children, permission }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    // Sem loja escolhida → volta para a telinha de entrada; senão, login.
    return <Navigate to={hasStoreSelected() ? '/login' : '/entrar'} replace />;
  }

  if (permission && !hasPermission(user, permission)) {
    // Redireciona para a home apropriada do usuário em vez de mostrar tela de "Acesso Negado"
    return <Navigate to={getHomeRoute(user)} replace />;
  }

  return children;
};
